import { useEffect, useRef, useState } from 'react';
import { Alert, Box, Button, Link, Stack, Typography } from '@mui/joy';
import { remainingLabel } from './additionalMeasurementUi';
import AdditionalMeasurementDialog from './AdditionalMeasurementDialog';

export default function AdditionalMeasurementPanel({ eventId, event, cycle, canStart = false, onChanged, compact = false }) {
  const [now, setNow] = useState(Date.now()), [open, setOpen] = useState(false);
  const clockOffset = useRef(0);
  useEffect(() => {
    const server = Date.parse(cycle?.server_now);
    clockOffset.current = Number.isFinite(server) ? server - Date.now() : 0;
    setNow(Date.now());
  }, [cycle?.id, cycle?.server_now]);
  useEffect(() => { setOpen(false); }, [eventId]);
  useEffect(() => {
    if (cycle?.status !== 'active') return undefined;
    const timer = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(timer);
  }, [cycle?.status, cycle?.due_at]);
  if (!cycle && !canStart) return null;
  return <Box sx={{ my: compact ? 0 : 1, minWidth: 0 }}>
    {cycle && <Alert color={cycle.status === 'active' ? 'danger' : 'neutral'} variant="soft" sx={compact ? {p: 1.25, borderRadius: '10px', alignItems: 'flex-start', overflowWrap: 'anywhere'} : undefined}><Stack spacing={0.5} sx={{minWidth: 0}}>
      <Typography level="title-sm">{cycle.status === 'active' ? 'Дополнительный обмер' : cycle.status === 'cancelled' ? 'Допобмер снят менеджером' : 'Допобмер завершён'}</Typography>
      {cycle.status === 'active' && <Typography>{remainingLabel(cycle.due_at, now + clockOffset.current)}</Typography>}
      {cycle.scheduled && <Typography level="body-sm" fontWeight={700}>Выезд: {cycle.scheduled}</Typography>}
      <Typography level="body-sm">{cycle.reason}</Typography>
      {cycle.status === 'cancelled' && <Typography level="body-sm">{cycle.cancel_reason}</Typography>}
      {(cycle.files || []).map(file => <Link key={file.url} href={file.url} target="_blank" rel="noopener noreferrer">{file.name}</Link>)}
    </Stack></Alert>}
    {canStart && cycle?.status !== 'active' && <Button size={compact ? 'sm' : undefined} sx={compact ? {mt: cycle ? 1 : 0} : undefined} color="warning" variant="soft" onClick={() => setOpen(true)}>Назначить допобмер</Button>}
    <AdditionalMeasurementDialog open={open} event={event} eventId={eventId} onClose={() => setOpen(false)} onChanged={onChanged} />
  </Box>;
}
